<template>
	<div class="flex flex-col gap-4">
		<div
			class="rounded-full bg-surface-disabled w-full h-6 animate-pulse"
		/>
		<div
			class="rounded-full bg-surface-disabled w-full h-6 animate-pulse"
			style="animation-delay: 0.15s"
		/>
		<div
			class="rounded-full bg-surface-disabled w-full h-6 animate-pulse"
			style="animation-delay: 0.3s"
		/>
	</div>
</template>
